import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'

import { Badge } from '../../../shared/NarusMaterial'
import { narusGrey6 } from '../../../shared/NarusMaterial/colors'

const calculateDateDiff = date => {
  const day = moment(date)
  const currentDay = moment().startOf('day')
  const dayDiff = day.diff(currentDay, 'days')

  if (dayDiff < 0) {
    return {
      color: 'red',
      dayDiff: -dayDiff
    }
  }

  return {
    color: 'blue',
    dayDiff
  }
}

class DueDays extends React.Component {
  renderScale () {
    const { date } = this.props
    let blueBoxes = []
    let blueCounter = 0
    const diff = calculateDateDiff(date)

    while (blueCounter <= diff.dayDiff) {
      blueBoxes.push(1)
      blueCounter++
    }

    if (blueBoxes.length > 7) {
      blueBoxes = blueBoxes.slice(0, 7)
    }

    const greyBoxNum = 7 - blueBoxes.length

    const greyBoxes = []
    let greyCounter = 0

    while (greyCounter < greyBoxNum) {
      greyBoxes.push(1)
      greyCounter++
    }

    const style = {
      box: {
        margin: '1px',
        color: diff.color
      },
      greyBox: {
        margin: '1px',
        color: narusGrey6
      },
      wrap: {
        width: '100px',
        marginRight: '10px'
      }
    }

    return (
      <div style={style.wrap}>
        {blueBoxes.map((box, index) => (
          <i
            key={index}
            className='fa fa-stop'
            style={style.box}
          />
        ))}
        {greyBoxes.map((box, index) => (
          <i
            key={index}
            className='fa fa-stop'
            style={style.greyBox}
          />
        ))}
      </div>
    )
  }

  renderSpot () {
    const { date, count } = this.props
    if (count >= 0) {
      return (
        <Badge
          color='blue'
          count={count}
        />
      )
    }
    if (count < 0) {
      return (
        <Badge
          color='red'
          count={count}
        />
      )
    }
    if (date) {
      const diff = calculateDateDiff(date)
      return (
        <Badge
          color={diff.color}
          count={diff.dayDiff}
        />
      )
    }
    return null
  }

  render () {
    const { type = 'spot' } = this.props
    if (type === 'spot') {
      return this.renderSpot()
    }
    if (type === 'scale') {
      return this.renderScale()
    }
    return null
  }
}

DueDays.propTypes = {

  date: PropTypes.any,
  count: PropTypes.number
}

export default DueDays
